module.exports = __webpack_public_path__ + "static/media/peking-luck.cf699f62.gif";